import { FC, Fragment } from "react";
import {
    Box,
    Heading,
    Text,
    Button,
    TableContainer,
    Table,
    Thead,
    Tbody,
    Th,
    Tr,
} from "@smile2impress/components/relaunch";
import { useGoToBooking } from "hooks/useGoToBooking";

import Link from "components/Link";

import { Row } from "./components";
import { TableWithCheckmarksProps } from "./TableWithCheckmarks.types";

export const TableWithCheckmarks: FC<TableWithCheckmarksProps> = ({
    content,
    headingAs,
}) => {
    const { title, cta, columns, rows } = content;

    const { goToBooking } = useGoToBooking();
    if (!cta.onClick && !cta.link) {
        cta.onClick = goToBooking;
    }
    const { text, onClick, link } = cta;
    const columnMaxW = `${100 / (columns.length + 1)}%`;

    return (
        <Box
            as="section"
            px={[0, 0, 4]}
            py={[3, 3, 4]}
            bgColor={["initial", "initial", "base.grey"]}
        >
            <Box textAlign={"center"} mb={3}>
                <Heading
                    textStyle={["H2"]}
                    color={["text.base"]}
                    as={headingAs}
                >
                    {title}
                </Heading>
            </Box>
            <TableContainer bgColor="white" p={[1, 1, 3]} borderRadius="sm">
                <Table variant="highlightFirstColumn">
                    <Thead>
                        <Tr>
                            <Th w={columnMaxW}></Th>
                            {columns.map((column, index) => (
                                <Th key={index} w={columnMaxW}>
                                    <Text
                                        textStyle={[
                                            "captionSmall",
                                            "captionSmall",
                                            "caption",
                                        ]}
                                        fontWeight={[
                                            "normal",
                                            "normal",
                                            "bold",
                                        ]}
                                        color="inherit"
                                    >
                                        {column}
                                    </Text>
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody>
                        <>
                            {rows
                                .filter(({ title }) => title.length > 0)
                                .map((row, index) => (
                                    <Fragment key={index}>
                                        <Row {...row} columnMaxW={columnMaxW} />
                                    </Fragment>
                                ))}
                        </>
                    </Tbody>
                </Table>
            </TableContainer>
            <Box mt={3}>
                <Button
                    as={Link}
                    {...(onClick ? { onClick } : {})}
                    {...(link ? { href: link } : {})}
                    width={"100%"}
                >
                    {text}
                </Button>
            </Box>
        </Box>
    );
};
